import { notifications } from "@mantine/notifications";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AxiosError } from "axios";

// import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

export const defaultQueryRetry = (failureCount: number, error: unknown): boolean => {
  if ((error as AxiosError).response?.status === 401) return false;

  // Show error notification only if the request fails completely (after retry)
  if (
    failureCount === 1 &&
    (error as AxiosError).response?.status === 500 &&
    (error as AxiosError).response?.config?.method?.toUpperCase() === "GET"
  ) {
    // TODO: Update notification with useAlert styling
    notifications.show({
      title: "Server Error",
      variant: "error",
      message: "Something went wrong on the server. Please try again later.",
      autoClose: 5000,
    });
  }

  //Cognito automatically refreshes the token if it's expired which causes API to fail once, thus setting retry to 1
  return failureCount < 1; // Retry once for all other errors
};

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 1000,
      gcTime: 10 * 60 * 1000,
      refetchOnWindowFocus: false,
      retry: defaultQueryRetry,
      retryDelay: 5000,
    },
  },
});

const QueryClientProviderWrapper = ({ children }: { children: React.ReactNode }) => {
  return (
    <QueryClientProvider client={queryClient}>
      {children}
      {/* <ReactQueryDevtools
        initialIsOpen={false}
        position='top'
        buttonPosition='top-right'
      /> */}
    </QueryClientProvider>
  );
};

export default QueryClientProviderWrapper;
